module.exports = __webpack_public_path__ + "471325683623d54262d0cdb2b92abc43.png";